import { Stack } from "@mui/joy";
import InvoiceCard from "./InvoiceCard";
import { IFInvoiceWithDetailsObj } from "@/types/interfaces/crm";

interface Props {
  invoices: IFInvoiceWithDetailsObj[];
  selectedInvoice: string;
  searchText: string;
  setSelectedInvoiceIndex: (index: number) => void;
  selectedInvoiceIndex: number;
}

export default function InvoicesList({ invoices, selectedInvoice, searchText, setSelectedInvoiceIndex, selectedInvoiceIndex }: Props) {

  return (
    <Stack gap={1} >
      {invoices.map((invoice, index) => (
        <InvoiceCard
          setSelectedInvoiceIndex={setSelectedInvoiceIndex!}
          selectedInvoiceIndex={selectedInvoiceIndex}
          index={index}
          searchText={searchText}
          key={invoice.invoiceId}
          selectedInvoice={selectedInvoice}
          invoice={invoice}
        />
      ))}
    </Stack>
  );
}
